<form
[formGroup]="form"
class="animated fadeIn fast"
[class.mt-10]="anyAlert() || loading"
appBlockCopyPaste
>
  <app-loading *ngIf="loading"></app-loading>
  <app-alert *ngIf="error" [alert]="error"></app-alert>
  <app-alert
    *ngIf="
      helpers.invalidControl(form.get('ruc')) &&
      !form.get('ruc').errors.required
    "
    [alert]="invalidRuc"
  ></app-alert>
  <div *ngIf="!loading">
    <div class="row">
      <div class="col-lg-12">
        <h4 class="subtitle primary">Ingresa los datos del administrador</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('ruc'))"
        >
          <label for="ruc" class="label-form label-create-form"
            >RUC de la Empresa</label
          >
          <input
            type="text"
            formControlName="ruc"
            class="form-control"
            maxlength="11"
            mask="0*"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('ruc'))"
          >
            <span *ngIf="form.get('ruc').errors.required">{{
              constants.validations.required.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group has-feedback"
          [class.has-error]="helpers.invalidControl(form.get('docType'))"
        >
          <label class="label-form" for="docType">Tipo de documento</label>
          <select
            class="form-control"
            formControlName="docType"
            (change)="onChange($event)"
          >
            <option value="" disabled selected>Seleccione</option>
            <option *ngFor="let type of docTypes" value="{{ type.value }}">
              {{ type.name }}
            </option>
          </select>
          <i
            class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
          ></i>
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('docType'))"
          >
            {{ constants.validations.required.message }}
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('docNumber'))"
        >
          <label class="label-form" for="docNumber">Número de documento</label>
          <input
            type="text"
            class="form-control"
            mask="0*"
            formControlName="docNumber"
            [maxlength]="maxLengthDoc"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('docNumber'))"
          >
            <span *ngIf="form.get('docNumber').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span
              *ngIf="
                form.get('docNumber').errors.pattern ||
                form.get('docNumber').errors.minlength ||
                form.get('docNumber').errors.maxlength
              "
              >{{
                constants.validations.docNumber.message(
                  form.get("docNumber").errors.minlength?.requiredLength || maxLengthDoc
                )
              }}</span
            >
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="!loading" class="row text-center">
      <button
        type="button"
        (click)="continue()"
        [disabled]="form.invalid || error?.blocked"
        class="button-continue button-find-label"
      >
        Continuar
      </button>
    </div>
    <div *ngIf="!loading" class="row text-center">
      <a [routerLink]="['/login/company']" class="primary green-link pointer">
        Volver >
      </a>
    </div>
  </div>
</form>
